import { ReactComponent as IconChevronDown } from '@/assets/svgs/chevron-down.svg'
import Popover from '@/components/Popover/index'
import classname from 'classnames'
import { produce } from 'immer'
import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'

const MultiSelectCheckbox = ({ "data-testid": dataTestId, addClass, items, label, onChangeFunc, showValues = false, emptyMessage = 'This is empty', disable }) => {
	const placeholder = label ? label : "Select"

	/*=================================================
		Filter Popup
	/================================================*/

	const [filterVisible, setFilterVisible] = useState(false)
	const buttonRef = useRef(null)
	const referenceRef = useRef(null)

	useEffect(() => {
		document.addEventListener('mousedown', handleDocumentClick)
		return () => {
			document.removeEventListener('mousedown', handleDocumentClick)
		}
	}, [])

	function handleDocumentClick(event) {
		if (!referenceRef.current) {
			return
		}

		if (referenceRef.current.contains(event.target)) {
			return
		}
		setFilterVisible(false)
	}

	if ((Array.isArray(items))) {
		const count = items.filter(item => item.$selected === true).length;

		function isAllChecked() {
			return items.every(field => field.$selected)
		}

		function changeListCheckboxes(event) {
			const index = items.findIndex(field => field.id === event.target.value)
			const updatedItem = produce(items, draft => {
				draft[index]['$selected'] = !draft[index]?.['$selected']
			})
			onChangeFunc(updatedItem)
		}

		function changeAllListCheckboxes(event) {
			if (event.target.checked) {
				const updatedItem = items.map(field => ({ ...field, $selected: true }))
				return onChangeFunc(updatedItem)
			}

			const updatedItem = items.map(field => ({ ...field, $selected: false }))
			onChangeFunc(updatedItem)
		}

		const list = items.map((field, index) => {
			return (
				<div className="card-configure__group__content__col" key={index}>
					<input type="checkbox"
						name={field.label || field.name}
						value={field.id}
						id={field.id}
						checked={field.$selected}
						onChange={(e) => changeListCheckboxes(e)}
					/>
					<label htmlFor={field.id}>{field.label || field.name}</label>
				</div>
			)
		})

		const classes = classname(
			addClass,
			{
				'multiCheckboxSelect__group': true,
			}
		);

		return (

			<div className={classes}>
				<Popover visible={filterVisible}
					options={{ modifiers: [{ name: 'offset', options: { offset: [0, 10] } }] }}
				>
					<Popover.Trigger
						style={{ display: 'block' }}
					>
						<div data-testId={dataTestId} className="multiCheckboxSelect__trigger" onClick={() => {
							if (!disable) {
								setFilterVisible(!filterVisible)
							}
						}}>
							{
								(count > 0) && (
									<span className="multiCheckboxSelect__selected">
										{showValues ?
											items.filter(item => item.$selected === true).map(item => item.label || item.name).join(', ') :
											`${count} Selected`
										}
									</span>
								)
							}
							{
								(count === 0) && (
									<span className="multiCheckboxSelect__selected-empty">
										{placeholder}
									</span>
								)
							}
							<IconChevronDown />
						</div>
					</Popover.Trigger>

					<Popover.Content>
						<div className="multiCheckboxSelect__content" ref={referenceRef} >
							<div className="multiCheckboxSelect__group__content">
								<div className="multiCheckboxSelect__group__content__cols">
									{
										list.length > 0 && (
											<>
												<div className="card-configure__group__content__col">
													<input type="checkbox"
														id="All"
														checked={isAllChecked()} onChange={(e) => changeAllListCheckboxes(e)} />
													<label htmlFor="All">All</label>
												</div>
												{list}
											</>
										)
									}
									{
										list.length === 0 && (
											<div className="card-configure__group__content__col">
												{emptyMessage}
											</div>
										)
									}
								</div>
							</div>
						</div>
					</Popover.Content>
				</Popover>
			</div>

		)
	}

	return 'Missing'
}

MultiSelectCheckbox.propTypes = {
	"data-testid": PropTypes.string,
	addClass: PropTypes.string,
	items: PropTypes.array,
	label: PropTypes.string,
	onChangeFunc: PropTypes.func,
	showValues: PropTypes.bool,
	emptyMessage: PropTypes.string,
	disable: PropTypes.bool
}

export default MultiSelectCheckbox
